import { Box, Typography } from '@mui/material';
import { Clock } from 'phosphor-react';
import { filterSearch } from '../../Utilis/filterSearch';
import { StrategyStep } from '../../Utilis/Types/Strategies';

type Props = {
  strategyStep: StrategyStep;
  searchQuery: string;
};
export const convertDate = (date: string, setHours: boolean = false) => {
  const newDate = new Date(date);

  const day = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const year = newDate.getFullYear();

  const hours = newDate.getHours();
  const minutes = newDate.getMinutes();

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${month}/${day}/${year} ${
    setHours ? formattedHours + ':' + formattedMinutes : ''
  }`;
};
const TaskList = ({ strategyStep, searchQuery }: Props) => {
  const filteredSteps = filterSearch(
    searchQuery,
    strategyStep?.tasks
  );

  return (
    <Box>
      <Typography
        sx={{
          marginTop: '16px',
          marginBottom: '8px',
        }}
        fontSize={'18px'}
        lineHeight={'22px'}
        fontWeight={'600'}
        color={'#202A2D'}
      >
        Tasks
      </Typography>
      {filteredSteps?.map((item, i) => {
        return (
          <Box
            key={i}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '10px 16px',
              alignItems: 'center',
              border: '1px solid #DBE0E2',
              borderRadius: '4px',
              marginBottom: '12px',
              gap: '10px',
              backgroundColor: 'white',
            }}
          >
            <Typography
              color={'#091E42'}
              fontSize={'16px'}
              fontWeight={'500'}
              lineHeight={'19px'}
              maxWidth={'300px'}
              width={'100%'}
            >
              {item.name}
            </Typography>
            {item?.description && (
              <Typography
                fontSize={'12px'}
                fontWeight={'400'}
                lineHeight={'16px'}
                color={'#655C68'}
              >
                {item.description}
              </Typography>
            )}
            {/* <Typography
              fontSize={'12px'}
              fontWeight={'400'}
              lineHeight={'16px'}
              color={'#655C68'}
            >
              Assigned to: {`${authUser?.name} ${authUser?.lastName}`}
            </Typography> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10.5px',
              }}
            >
              <Clock size={20} color='#655C68' />
              <Typography
                fontSize={'14px'}
                fontWeight={'400'}
                lineHeight={'19px'}
                color={'#655C68'}
              >
                {"Due date: " + convertDate(
                  !!item.completed ? item.completedDate : item.targetDate
                )}
              </Typography>
            </Box>
            <Typography
              fontSize={'14px'}
              fontWeight={'400'}
              lineHeight={'17px'}
              color={!!item?.completed ? '#009E7D' : '#1F76C7'}
              sx={{
                maxWidth: '80px',
                width: '100%',
                paddingY: '8px',
                textAlign: 'center',
                borderRadius: '3px',
                backgroundColor: !!item.completed ? '#E3F2EE' : '#D9ECFD',
              }}
            >
              {!!item.completed ? 'Complete' : 'In Progress'}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default TaskList;
